(function () {
    'use strict';

    angular
        .module('app')
        .controller('LeadsController', LeadsController);

    LeadsController.$inject = ['$state',];

    function LeadsController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'leads') {
                $state.go('leads.list');
            }
        }
    }
})();